import * as React from 'react'

const EditIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='20'
      height='17'
      viewBox='0 0 20 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.63199 13.361V1.67002H12.4221L14.0175 0L0 0V15.0783H15.6694V6.4002L14.0175 8.03942V13.361H1.63199Z'
        transform='translate(0 1.92188)'
        fill='#666666'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2404 0L0 10.3718V12.2367H1.83355L12.0807 1.8607L10.2404 0Z'
        transform='translate(6.20264 1.67285)'
        fill='#666666'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.87353 0.227502C1.71796 0.0867773 1.51193 0 1.28943 0C1.06682 0 0.862892 0.0868364 0.709597 0.227739L0 0.946446L0.664163 1.61919L1.89169 2.86259L2.60123 2.14388C2.74039 1.9886 2.82262 1.78204 2.82262 1.55655C2.82262 1.33118 2.74039 1.12243 2.60146 0.964902L1.87353 0.227502Z'
        transform='translate(17.1777)'
        fill='#666666'
      />
    </svg>
  )
}

export default EditIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/Edit.tsx